import i18nLocale from "@/helpers/locale";
import { email_reg, colorReg } from "@/utils/regExp.js";

export const digitValidator = (_, value, callback) => {
  if (value === "" || value === null) {
    callback();
  } else if ((/^[0-9]*$/).test(value.toString())) {
    callback();
  } else {
    callback(new Error(i18nLocale("form.mustFillInNum")));
  }
};

export const positiveNumValidator = (_, value, callback) => {
  if (value === "" || value === null) {
    callback();
  } else if (Number(value) >= 0) {
    callback();
  } else {
    callback(new Error(i18nLocale("form.mustFillInPositiveNum")));
  }
};

export const percentageValidator = (_, value, callback) => {
  if (value === "" || value === null) {
    callback();
  } else if (Number(value) >= 0 && value.toString().length <= 3) {
    callback();
  } else {
    callback(new Error(i18nLocale("form.plsEnterCorrectPercentage")));
  }
};

export const emailValidator = (_, value, callback) => {
  if (value === "" || value === null) {
    callback();
  } else if (email_reg.test(value)) {
    callback();
  } else {
    callback(new Error("有効なメールアドレスを入力してください。"));
  }
};

export const hexColorValidator = (_, value, callback) => {
  if (value === "" || value === null) {
    callback();
  } else {
    const _len = value.length;
    if ((_len === 4 || _len === 7) && colorReg.test(value)) {
      callback();
    }
    callback(new Error(i18nLocale("form.hexColorError")));
  }
};